var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17 (82) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.7528 20.7316H13.6036V15.5285H15.3053C15.7368 15.5285 15.9918 15.0381 15.7368 14.685L12.4266 10.1047C12.2158 9.81044 11.7793 9.81044 11.5684 10.1047L8.25827 14.685C8.00327 15.0381 8.25337 15.5285 8.68982 15.5285H10.3915V20.7316H4.62444C2.04986 20.5894 0 18.1815 0 15.5726C0 13.7728 0.975889 12.2036 2.42256 11.3552C2.29015 10.9972 2.2215 10.6147 2.2215 10.2126C2.2215 8.37358 3.7074 6.88768 5.54638 6.88768C5.9436 6.88768 6.32611 6.95634 6.6841 7.08874C7.74826 4.83292 10.0433 3.26855 12.7111 3.26855C16.1635 3.27346 19.0078 5.9167 19.3314 9.28572C21.9845 9.74179 24 12.1987 24 14.9792C24 17.951 21.6853 20.5256 18.7528 20.7316Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.7c1105102ebb9bda13006ffbb6dbb403.svg";
export { ForwardRef as ReactComponent };